<!-- modal.component.html -->
<ng-template #modalTpl let-modal>
    <div class="modal-header">
        <h5 class="modal-title">{{ modalConfig.modalTitle }}</h5>
        <button *ngIf="!modalConfig.hideCloseButton" type="button" class="btn-close" aria-label="Close"
            (click)="close()"></button>
    </div>

    <div class="modal-body">
        <ng-container *ngTemplateOutlet="template"></ng-container>
    </div>

    <div class="modal-footer" *ngIf="!modalConfig.hideDismissButton || !modalConfig.hideCloseButton">
        <button *ngIf="!modalConfig.hideDismissButton" type="button" class="btn btn-outline-secondary"
            (click)="dismiss()">
            {{ modalConfig.dismissButtonLabel || 'Cancelar' }}
        </button>
        <button *ngIf="!modalConfig.hideCloseButton" type="button" class="btn btn-outline-danger" (click)="close()">
            {{ modalConfig.closeButtonLabel || 'Fechar' }}
        </button>
    </div>
</ng-template>